import { render, staticRenderFns } from "./questions-table.vue?vue&type=template&id=224e5665&scoped=true&"
import script from "./questions-table.vue?vue&type=script&lang=js&"
export * from "./questions-table.vue?vue&type=script&lang=js&"
import style0 from "./questions-table.vue?vue&type=style&index=0&id=224e5665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e5665",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
